<template>
  <div class="width-fit-content">
    <div @click="handleClick" class="drop-btn tw-bg-blue-25">
      <RoundedUserAvatar :size="32" />
      <AppIcon :direction="arrowDirection" id="profile-settings" class="tw-fill-blue-gray-600" icon="arrow" />
    </div>
  </div>
</template>

<script>
import AppIcon from '@/v2/components/ui/icon/AppIcon.vue'
import RoundedUserAvatar from './RoundedUserAvatar.vue'

export default {
  components: { RoundedUserAvatar, AppIcon },
  data() {
    return {
      arrowDirection: 'down',
      open: false,
    }
  },

  methods: {
    handleClick() {
      this.open = !this.open
      this.arrowDirection = this.open ? 'up' : 'down'
      this.$emit('click', this.open)
    },
    setOpenState(val) {
      this.open = val
      this.arrowDirection = val ? 'up' : 'down'
    },
  },
}
</script>

<style scoped>
.drop-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 6px 8px;
  border: 1px solid var(--v-outlineLight-base);
  border-radius: 360px;
}
</style>
